import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";
import SessaoEncerrada from "../pages/SessaoEncerrada";

const Route = ({ component: Component, isPrivate = false, ...rest }) => {
  const { isAuth, loading, user } = useContext(AuthContext);

  // Sem sessão em rota privada: tela de sessão encerrada. Antes não renderizava nada — o Redirect
  // para /login segue comentado de propósito (descartava o deep link do CRM) e o resultado era
  // tela branca, sem dizer ao usuário o que tinha acontecido.
  if (!isAuth && isPrivate) {
    return <>{loading ? <BackdropLoading /> : <SessaoEncerrada />}</>;
  }

  // Usuário autenticado e desativado tentando acessar rota privada → bloqueio.
  if (isAuth && isPrivate && user && user.ativo === false) {
    return <Redirect to="/blocked-user" />;
  }

  // Autenticado, mas fora do horário de acesso → tela do horário.
  if (isAuth && isPrivate && user && user.foraHorarioAcesso === true) {
    return <Redirect to="/fora-horario-acesso" />;
  }

  // Rota não-privada (apenas /login/...) com usuário autenticado: NÃO
  // redirecionar para "/tickets" — isso descartava o deep link do CRM
  // (página/ticket/funil). Renderiza o Login, que roda o handleLogin e navega
  // para o destino correto. Exceção: usuário desativado vai para o bloqueio.
  if (isAuth && !isPrivate) {
    if (user && user.ativo === false) {
      return <Redirect to="/blocked-user" />;
    }
    if (user && user.foraHorarioAcesso === true) {
      return <Redirect to="/fora-horario-acesso" />;
    }
    return (
      <>
        {loading && <BackdropLoading />}
        <RouterRoute {...rest} component={Component} />
      </>
    );
  }

  return (
    <>
      {loading && <BackdropLoading />}
      <RouterRoute {...rest} component={Component} />
    </>
  );
};

export default Route;
